<template>
  <ModalContainer :show="show" @close="onCancel">
    <template slot="header">
      <h4 class="mb-0">{{ $t("create_geofence") }}</h4>
    </template>
    <template slot="body">
      <div class="action-summary">
        <p>{{ $t("create_geofence_instructions") }}</p>
      </div>

      <div class="error-msg" v-if="geofenceAlert">
      {{ $t('cannot_process') }}
      </div>

      <div class="my-3">
        <div class="form-group">
          <label for="">{{ $t("search_location") }}</label>
          <div class="d-flex" style="column-gap:5px">
            <input
              type="text"
              class="form-control"
              id="autocomplete"
              :placeholder="$t('enter_location')"
            />
            <!-- <button @click="doSearch" class="btn btn-primary">
            search
          </button> -->
          </div>
        </div>
      </div>
      <div>
        <label for="">{{ $t("map_type") }}</label>
        <div class="form-group">
          <select
            class="form-control"
            style="height: 50px"
            name="mapType"
            v-model="mapType"
          >
            <option value="roadmap">{{ $t("road_map") }}</option>
            <option value="satellite">{{ $t("satellite") }}</option>
            <option value="terrain">{{ $t("terrain") }}</option>
            <option value="hybrid">{{ $t("hybrid") }}</option>
          </select>
          <div class="dropdown-arrow">
            <img src="../assets/images/down-arrow.svg" alt="" height="6px" />
          </div>
        </div>
      </div>
      <form @submit.prevent="addgeofence" class="">
        <label for="">{{ $t("geofence_color") }}</label>
        <div class="form-group">
          <select
            class="form-control"
            style="height: 50px"
            name="color"
            v-model="color"
            :disabled="isDisabled"
          >
            <option value="black">{{ $t("black") }}</option>
            <option value="white">{{ $t("white") }}</option>
            <option value="red">{{ $t("red") }}</option>
            <option value="blue">{{ $t("blue") }}</option>
            <option value="green">{{ $t("green") }}</option>
            <option value="yellow">{{ $t("yellow") }}</option>
            <option value="orange">{{ $t("orange") }}</option>
          </select>
          <div class="dropdown-arrow">
            <img src="../assets/images/down-arrow.svg" alt="" height="6px" />
          </div>
        </div>
        <div class="form-group">
          <label for="">{{ $t("geofence_name") }}</label>
          <input
            type="text"
            class="form-control"
            v-model="name"
            required
            :disabled="isDisabled || editGeo.id "
          />
        </div>
        <div class="form-group">
          <div class="d-flex justify-content-end">
            <!-- <button
              type="button"
              class="mr-2 btn-maps btn-secondary"
              @click="reset"
              :disabled="isDisabled"
            >
              {{ $t("reset") }}
            </button> -->
            <button
              type="submit"
              class="btn btn-primary"
              :disabled="isDisabled"
            >
              {{ $t("save") }}
            </button>
          </div>
        </div>
      </form>
      <!-- <div class="poi-header" v-if="geofence.length > 0">
        {{ $t("other_geofences") }}
      </div> -->
      <!-- <div style="max-height: 300px; overflow-y:auto" class="mt-3">
        <div
          :key="geofence._id"
          v-for="geofence in geofence"
          class="device-container d-flex justify-content-between align-items-center mb-3 p-4"
        >
          <div>
            {{ geofence.name }}
          </div>
          <div class="delete-poi" @click="deletegeofence(geofence._id)">
            {{ $t("delete") }}
          </div>
        </div>
      </div> -->
    </template>
  </ModalContainer>
</template>

<script>
import IconCancel from "./Iconsvg/IconCancel";
import { mapGetters } from "vuex";
import ModalContainer from "./ModalContainer.vue";
import NotificationBox from "./NotificationBox.vue";
// import loadGoogleMapsApi from "load-google-maps-api";
// import $Scriptjs from "scriptjs";

export default {
  name: "createGeofence",
  props: {
    show: Boolean,
    isDisabled: Boolean,
    geofenceAlert: Boolean,
    map: null,
    editGeo:Object,
  },
  components: {
    IconCancel,
    ModalContainer,
    NotificationBox,
  },
  data() {
    return {
      name: "",
      color: "green",
      location: "",
      value: "",
      mapType: "roadmap",
    };
  },
  computed: {
    ...mapGetters(["geofence"]),
  },
  methods: {
    onCancel() {
      this.$emit("closeCreateGeofence");
    },
    reset() {
      this.$emit("reset_map");
      this.color = "green";
      this.location = "";
      this.name = "";
      this.mapType = "roadmap";
      this.doSearch();
    },
    doSearch() {
      this.$emit("searchLocation", this.location);
    },
    addgeofence() {
      this.$emit("addgeofence", {
        name: this.name,
        color: this.color,
        mapType: this.mapType,
      });
      this.name = "";
      this.color = "green";
      this.mapType = "roadmap";
    },
    deletegeofence(id) {
      this.$emit("delete-geofence", id);
    },
    initializeAutocomplete() {
      const { google } = window;
      this.geocoder = new google.maps.Geocoder();
      const input = document.getElementById("autocomplete");
      const autocomplete = new google.maps.places.Autocomplete(input);
      autocomplete.bindTo("bounds", this.map);

      google.maps.event.addListener(autocomplete, "place_changed", () => {
        var curPlace = autocomplete.getPlace();
        this.autoComplete = curPlace.formatted_address;
        const inputAddress = document.getElementById("autocomplete").value;

        if (typeof curPlace.formatted_address !== "undefined") {
          this.$emit("searchLocation", {
            location: inputAddress,
            viewport: curPlace,
          });
        }
      });
    },
  },
  watch: {
    color: {
      handler: function() {
        this.$emit("color", {
          color: this.color,
          name: this.name,
          mapType: this.mapType,
        });
      },
    },
    mapType: {
      handler: function() {
        this.$emit("color", {
          color: this.color,
          name: this.name,
          mapType: this.mapType,
        });
      },
    },
    name: {
      handler: function() {
        this.$emit("color", {
          color: this.color,
          name: this.name,
          mapType: this.mapType,
        });
      },
    },
    map: {
      handler: function() {
        this.initializeAutocomplete();
      },
    },
    geofenceAlert: {
      handler: function() {
        if (this.geofenceAlert) {
          setTimeout(() => {
            this.$emit("clear_geofenceAlert");
          }, 60000);
        }
      },
    },
  },
};
</script>

<style scoped>
.container {
  width: 300px;
  background: #fff;
  position: absolute;
  right: 0;
  top: 64px;
  height: calc(100% - 64px);
  padding: 28px 20px;
  display: none;
  /* overflow: hidden; */
  transition: 0.3s ease-out;
  z-index: 2;
  overflow-y: auto;
}
.container.show {
  display: block;
}
.action-summary {
  padding: 10px;
  background: #f2f5f7;
  margin-bottom: 26px;
}
.btn-maps {
  /* background: #f2f5f7; */
  padding: 10px 23px;
  /* color: #30b24b; */
  /* border: 1px solid #e1e7ec; */
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
  border-radius: 3px;
  outline: none;
}
.device-container {
  height: 50px;
  /* border-bottom: ; */
  box-shadow: 0px 1px 0px #e1e7ec;
}
.delete-poi {
  font-style: italic;
  font-size: 14px;
  line-height: 18px;
  cursor: pointer;
  color: #2980b9;
}
.poi-header {
  padding-left: 10px;
  font-style: italic;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  color: #2980b9;
}

.pac-container {
  z-index: 2001 !important;
}

select {
  -webkit-appearance: none;
  -moz-appearance: none;
}

select::-ms-expand {
  display: none;
}

.error-msg {
  background: #f8e2ea;
  padding: 6px 15px;
  border-radius: 6px;
  color: #a8286f;
}
</style>
